
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/register-success",
      function () {
        return require("private-next-pages/mobiworkx/register-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/register-success"])
      });
    }
  